module.exports = __webpack_public_path__ + "img/6.523bdd70.png";